import { Text } from '@chakra-ui/react';
import React from 'react';

import { useSettingsContext } from 'lib/contexts/settings';
import * as mixpanel from 'lib/mixpanel/index';
import type { ButtonProps } from 'toolkit/chakra/button';
import { Button } from 'toolkit/chakra/button';
import { Tooltip } from 'toolkit/chakra/tooltip';
import IconSvg from 'ui/shared/IconSvg';

interface Props extends ButtonProps {}

const TimeFormatToggle = (props: Props) => {
  const settings = useSettingsContext();
  const timeFormat = settings?.timeFormat || 'relative';

  const handleClick = React.useCallback(() => {
    settings?.toggleTimeFormat();
    mixpanel.logEvent(mixpanel.EventTypes.BUTTON_CLICK, { Content: 'Switch time format', Source: 'Table header' });
  }, [ settings ]);

  return (
    <Tooltip content="Toggle time format">
      <Button
        size="xs"
        display="inline-flex"
        variant="plain"
        aria-label="Toggle time format"
        onClick={ handleClick }
        selected={ timeFormat === 'absolute' }
        borderRadius="sm"
        ml={ 2 }
        border="1px solid"
        borderColor={{ _light: 'defaultBlack.300', _dark: 'defaultBlack.600' }}
        backgroundColor={{ _light: 'white', _dark: 'black' }}
        // verticalAlign="bottom"
        { ...props }
      >
        <IconSvg name="toggle-left" boxSize="16px"/>
        <Text>DATE</Text>
      </Button>
    </Tooltip>
  );
};

export default React.memo(TimeFormatToggle);
